import Settings from './settings/Settings';
import Modal from './modal/Modal';
import Widget from './widget/Widget';

export default {
  Settings,
  Modal,
  Widget
};



// WEBPACK FOOTER //
// ./src/apps/index.js